import { useCallback } from 'react';
import { useAppSelector } from './redux-hooks';
import { uiString, uiTemplate, UiKey } from '../localization/uiStrings';

export function useUiString() {
    const locale = useAppSelector((state) => state.menu.locale);
    return useCallback((key: UiKey) => uiString(locale, key), [locale]);
}

export function useUiTemplate() {
    const locale = useAppSelector((state) => state.menu.locale);
    return useCallback(
        (key: UiKey, params: Record<string, string>) => uiTemplate(locale, key, params),
        [locale]
    );
}
